export default __webpack_public_path__ + "static/howto-recruiters1-c95a2fc0824ca8df5df8325abecb646b.svg";